import { render, staticRenderFns } from "./filter-dialog.vue?vue&type=template&id=22063bb4&scoped=true"
import script from "./filter-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./filter-dialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22063bb4",
  null
  
)

export default component.exports